import loadable from '@loadable/component';

// 懒加载组件
const CstProcureConfirmationManagement = loadable(() => import('./cstProcureConfirmationManagement/Yl2yCstProcureConfirmationManagement'));
const CstProcureConfirmationModify = loadable(() => import('./cstProcureConfirmationManagement/cstProcureConfirmationModify/Yl2yCstProcureConfirmationModify.js'));
const HosItemPriceQuery = loadable(() => import('./hosItemPriceQuery/HosItemPriceQuery'));
const PaymentApplicationManagement = loadable(() => import('./paymentApplicationManagement/PaymentApplicationManagement'));
const PaymentApplicationInvoiceModify = loadable(() => import('./paymentApplicationManagement/paymentApplicationInvoiceModify/PaymentApplicationInvoiceModify'));
const OrderManagement2310 = loadable(() => import('./orderManagement2310/OrderManagement'));
const CstStatementConfirmationManagement = loadable(() => import('./cstStatementConfirmationManagement/CstStatementConfirmationManagement'));
const CstStatementConfirmationModify = loadable(() => import('./cstStatementConfirmationManagement/cstStatementConfirmationModify/CstStatementConfirmationModify'));

export const subRoutes = [
  {
    path: '/CstProcureConfirmationManagement',
    component: CstProcureConfirmationManagement
  },
  {
    path: '/CstProcureConfirmationModify',
    component: CstProcureConfirmationModify
  },
  {
    path: '/HosItemPriceQuery',
    component: HosItemPriceQuery
  },
  {
    // M827258002: 供应商：【榆林2院】发票上交申请管理
    path: '/PaymentApplicationManagement',
    component: PaymentApplicationManagement
  },
  {
    // M827258002: 供应商：【榆林2院】发票上交申请管理
    path: '/PaymentApplicationInvoiceModify',
    component: PaymentApplicationInvoiceModify
  },
  {
    // M253012【榆林2院】供应商：订单查询响应
    path: '/OrderManagement2310',
    component: OrderManagement2310
  },
  {
    // M258001【榆林2院】销售结算确认管理
    path: '/CstStatementConfirmationManagement',
    component: CstStatementConfirmationManagement
  },
  {
    // M258001【榆林2院】销售结算确认管理 - 明细
    path: '/CstStatementConfirmationModify',
    component: CstStatementConfirmationModify
  }
];
